 <div class="error-page">
    <h1>403</h1>
    <p>Access Denied</p>
    <a routerLink="/admission/student-form">Go Home</a>
  </div>
